define('views/user/directdeposit/directdeposit',[
    'backbone',
    'text!views/user/directdeposit/directdeposit.html',
    'views/_base/baseview',
    'models/shared/user/user'
], function(Backbone, Template, BaseView, User){
    'use strict';

    return BaseView.extend({
        id       : 'directDepositForm',
        tagName  : 'Section',
        template : _.template(Template),
        isRender : false,
        needsAuth: true,
        events   : {
            'click #closeDD': 'closeDD'
        },

        initialize: function(options){
            options = options || {};

            this.accountGUID = options.accountGUID;
            this.regType = options.regType;            
            this.DAAcct = '';
            this.ABART = '';
            this.BankName = '';

            this.elementName = options.elementName;

            _.bindAll(this, 'render');

            BaseView.prototype.initialize(this);
        },

        render: function(){
            var data = this.model.toJSON();

            this.$el.html(this.template({ data: data, DAAcct: this.DAAcct, ABART: this.ABART, BankName:this.BankName }));
            
            return this;    
        },

        loadData: function () {
            var that = this;

            store.getStoreItem(enums.modelsEnum.UserInfo, { ID: pf.session.get('UserGUID') }, false, true, true, function (Data) {
                that.model = new User(Data);
            });

            $.ajax({
                type: 'GET',
                //async:false,
                url: pf.consumerURL + '/DirectDeposit',
                contentType: 'application/json',
                success: function(model, resp){

                    that.DAAcct = model.DAAcct;
                    that.ABART = model.ABART;
                    that.BankName = model.BankName;

                    that.render();

                },
                error: function(model,resp){

                    that.close();

                }
            });

        },
    
        closeDD: function(e){
            if(e && e.preventDefault){ e.preventDefault(); }
            if(e && e.stopPropagation){ e.stopPropagation(); }

            window.close();
        },

        close: function(){
            pf.popupboxclose();
        }

    });
});

